import type { Message } from "./types";

export const GENERATION_ERROR_REPLY = "Sorry, I encountered an error. Please try again.";

export function failedGenerationMessages(messages: Message[]) {
  const next = [...messages];
  const failure: Message = { role: "assistant", content: GENERATION_ERROR_REPLY };
  if (next[next.length - 1]?.role === "assistant") {
    next[next.length - 1] = failure;
  } else {
    next.push(failure);
  }
  return next;
}
